import { PayloadAction } from "@reduxjs/toolkit";

export function isReduxAction(action: any): action is PayloadAction {
  return action !== undefined && "type" in action && "match" in action;
}
